import themeSelectorMediaConfig from './themeSelectorMedia.json';

export const THEME_SELECTOR_MEDIA = themeSelectorMediaConfig;

export type ThemeSelectorCardKey = keyof typeof themeSelectorMediaConfig.cards;
